<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="UserId"
      ref="list"
      unit="用户"
      :expand-all-row="true"
      :page="page"
      :show-checkbox="true"
      :show-query="true"
      :get-data-func="getDataFunc"
      urlHash="sys/user"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
        <el-table-column v-if="EditIsSuper" align="center" prop="IsSuper" label="超级" :width="$store.state.isMB?'50px':'80px'" >
          <template slot-scope="{row}">
            <el-tag type="success" v-if="row.IsSuper">是</el-tag>
            <el-tag type="danger" v-else>否</el-tag>
          </template>
        </el-table-column>
      </template>
    </list>
  </div>
</template>
<script>
const loginInfo = JSON.parse(localStorage.getItem("loginInfo")); // <!-- h -->
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import roleSelect from "@/components/sys/role/select";
import formColumn from "@/data/sys/user/IForm.json";
export default {
  mixins: [listMixin],
  components: { list, roleSelect },
  data() {
    return {
      EditIsSuper: false, // <!-- h -->
      api: require("@/api/sy/user").default,
      fromData: formColumn.Data,
      params: {
        Name: "",
        LoginId: "",
        RoleId: null,
        Status: null,
      },
    };
  },
  methods: {
    getDataFunc(params = {}) {
      this.EditIsSuper = loginInfo.IsSuper; // <!-- h -->      
      return new Promise((resolve) => {
        this.api.list({ ...params }).then((res) => {
          resolve({ ...res, Data: res.Data });
        });
      });
    },
    //
    getFormData() {
      let modeName = location.hash.split("/").slice(1).join("");
      this.formApi.list({ type: modeName }).then((res) => {
        if (res.Data === null || res.Data.length === 0) return;
        if (res.Code == 0) {
          const ShowField = res.Data.map((x) => x.ShowField);
          this.fromData.map((item) => {
            item.show = ShowField.indexOf(item.field) !== -1 ? true : false;
          });
        }
      });
    },

    logout(data) {
      console.log("logout", data);
      this.api.forceLogout({ UserId: data.UserId }).then((res) => {
        this.reload();
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>
